<template>
    <div id="login_box">
		<language-select></language-select>
        <img class="logo" src="../assets/images/logo.png">
        <h2 v-translate>Přihlášení do systému</h2>
        <div class="error" v-if="errorMessage">
            <div class="inner_box"><p>{{ this.errorMessage }}</p></div>
        </div>
        <form @submit.prevent="login">
            <p class="field">
                <label for="login" v-translate>Přihlašovací jméno</label>
                <input v-model="username" id="login" name="login" size="30" value="" type="text"/>
            </p>
            <p class="field">
                <label for="passsword" v-translate>Heslo</label>
                <input v-model="password" id="passsword" name="passsword" size="30" value="" type="password"/>
            </p>
            <p class="login_buttons">
                <input class="btn" type="submit" :value="'Přihlásit' | translate">
<!--                <router-link :to="{ name: 'forgotten-password' }" v-translate>Zapomenuté heslo</router-link>-->
            </p>
        </form>
    </div>
</template>

<script>
	import {AUTH_REQUEST, AUTH_UPDATE, SET_OWNER_SETTING} from "@/store/mutation-types"
	import userSettings from "@/components/mixins/user-settings"
	import LanguageSelect from "@/components/common/LanguageSelect"

	export default {
		name: "login",
		components: {
			LanguageSelect
		},
        mixins: [userSettings],
		data() {
			return {
				errorMessages: [],
				username: '',
				password: '',
			}
		},
		created(UserService) {
			this.userService = UserService
		},
		computed: {
			errorMessage() {
				return this.errorMessages[0]
			}
		},
		methods: {
			login: function () {
				const {username, password} = this
				this.$store.dispatch(AUTH_REQUEST, {username, password})
					.then(() => {
            this.setOwnerSetting('selected-operator-id', null);
            this.setOwnerSetting('selected-operator-name', null);
						this.userService.getLoggedUserData()
							.then(data => {
								this.$store.dispatch(AUTH_UPDATE, {
									full_name: data.user.name,
									user_name: data.user.login,
									user_role: data.user.role,
                  user_role_list: data.user.role_list,
                  operator_role_list: data.user.operator_role_list,
									user_image: data.user.image,
									operator_id: data.user.id_operator,
									operator_name: data.user.operator_name,
                  logged_operator: data.operator,
								})

                if (this.$route.query.hasOwnProperty('redirect')) {
                  this.$router.push({path: this.$route.query.redirect});
                } else {
                  this.$router.push({name: 'subscribers'});
                }
							})
							.catch(() => {
								this.errorMessages = [this.$gettext('Nepodařilo se získat další informace o uživateli.')]
							})
					})
					.catch((error) => {
						if (error['operator_inactive'] === true) {
							this.errorMessages = [this.$gettext('Služba byla pozastavena, obraťte se na jejího poskytovatele.')]
						} else {
							this.errorMessages = [this.$gettext('Chyba přihlášení.')]
						}
					})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue